"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Collapse2 = _interopRequireDefault(require("@material-ui/core/Collapse"));

var React = _interopRequireWildcard(require("react"));

var _styles = require("@material-ui/core/styles");

var useStyles = (0, _styles.makeStyles)(function () {
  return {
    container: {
      opacity: 0,
      transition: 'opacity 0.25s cubic-bezier(0.215, 0.61, 0.355, 1), height 0.25s cubic-bezier(0.645, 0.045, 0.355, 1)'
    },
    entered: {
      opacity: 1
    }
  };
}, {
  name: 'PdsAccordionTransition'
});

var AccordionTransition = function AccordionTransition(props) {
  var classes = useStyles();
  return /*#__PURE__*/React.createElement(_Collapse2.default, Object.assign({}, props, {
    classes: classes
  }));
};

var _default = AccordionTransition;
exports.default = _default;
